import { render } from "./ds-otop-norm-view.vue?vue&type=template&id=549263ba"
import script from "./ds-otop-norm-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ds-otop-norm-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/ds-otop-norm-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "549263ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('549263ba', __exports__)) {
    api.reload('549263ba', __exports__)
  }
  
  module.hot.accept("./ds-otop-norm-view.vue?vue&type=template&id=549263ba", () => {
    api.rerender('549263ba', render)
  })

}


export default __exports__